<template>
  <b-modal
    :ok-disabled="formSubmitted"
    id="uploadFileModal"
    :centered="true"
    :title="modalTitle"
    :hide-footer="true"
    @shown="getPolicyDetails"
    @hidden="hideModal()"
    size="md"
    no-close-on-backdrop
  >
    <form>
      <label for="plan">
        {{ row?.status === "submitted" ? "Selected Plan" : "Select Plan" }}
      </label>
      <span class="input-required"> * </span><br />
      <select
        :state="validateState('plan_id')"
        class="form-control w-100 mb-3"
        v-model="$v.form.plan_id.$model"
        :disabled="row?.status === 'submitted'"
      >
        <option disabled value="">{{ "Please Select a Plan" }}</option>
        <option
          v-for="plan in plan_details"
         :key="plan.policy_id + '-' + plan.plan_id"
          :value="plan.plan_id"
        >
          {{ plan.plan_name }}
        </option>
      </select>
      <div v-if="showError('plan_id')" class="error-message">
        Please select a plan
      </div>

      <label for="file">{{ fileLabel }}</label>
      <template v-if="row?.status !== 'submitted'">
        <span class="input-required"> * </span><br />
        <input
          ref="fileInput"
          class="w-100 mb-3"
          type="file"
          id="fileInput"
          name="fileInput"
          multiple
          @change="fileSelected"
          :disabled="row?.status === 'submitted'"
        />
        <button
          type="button"
          class="choose-file-btn"
          @click="triggerFileInput"
          :disabled="row?.status === 'submitted'"
        >
          Drop files here or "Browse"
        </button>
        <div v-if="showError('files')" class="error-message">
          Please Upload file
        </div>
      </template>

      <div class="d-flex flex-wrap">
        <div
          class="mb-2 file-name-wrap pl-2 pb-1"
          v-for="(file, index) in form.files"
         :key="`uploaded-${file.id || `${file.filename}-${index}`}`"
        >
          <span class="pr-3 ">{{ file.name }}</span>
          <div
            class="close-icon"
            @click="removeFile(index)"
            v-if="row?.status !== 'submitted'"
          >
            <i class="fas fa-times ml-2"></i>
          </div>
        </div>
      </div>
      <template v-if="isEdit && form.file_lists && form.file_lists.length > 0">
        <div class="d-flex flex-wrap">
          <div
            class="mb-2 file-name-wrap pl-2 pb-1"
            v-for="(file, index) in form.file_lists"
          :key="`fileList-${file.filename}-${index}`"
          >
            <span class="pr-3">{{ file.filename }}</span>
            <div
              class="close-icon"
              @click="removeFileLists(file.id, index)"
              v-if="row?.status !== 'submitted'"
            >
              <i class="fas fa-times ml-2"></i>
            </div>
          </div>
        </div>
      </template>

      <template v-if="row?.status === 'submitted' && form.description">
      <label for="description">Remarks</label><br />
      <p v-if="row?.status === 'submitted'">{{ form.description }}</p>
      
    </template>
    <template v-else-if="row?.status !== 'submitted'">
      <label for="description">Remarks</label><br />
      <textarea
        class="w-100"
        v-model="form.description"
        rows="1"
      ></textarea>
    </template>
      <div v-if="row?.status !== 'submitted'" class="submit-btn">
        <button @click.prevent="submitFiles">
          {{ isEdit ? "Update" : "Submit" }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import helper from "../../resource/Helper";

function initialState() {
  return {
    form: {
      claim_type: "MEMBER",
      plan_id: "",
      files: [],
      file_lists: [],
      description: "",
      deleted_files: [],
    },
    plan_details: [],
    formSubmitted: false,
    originalFileLists:[]
  };
}

export default {
  props: {
    row: { required: false },
    isEdit: { required: false },
  },
  data() {
    return initialState();
  },
  watch: {
    isEdit(val) {
      if (val && this.row) {
        this.form.plan_id = this.row.pid || "";
        this.form.files = [];
        this.form.file_lists = this.row.files;
        this.form.description = this.row?.description || "";
      }
    },
    row(val) {
      if (this.isEdit && val) {
        this.form.plan_id = val.pid || "";
        this.form.files = [];
        this.form.file_lists = val.files;
        this.originalFileLists=val.files;
        this.form.description = this.row.description || "";
      }
    },
  },
  computed: {
    fileLabel() {
      return this.row?.status === "submitted"
        ? this.form.files.length === 1
          ? "Uploaded File"
          : "Uploaded Files"
        : "Upload File";
    },
    modalTitle() {
      if (this.row?.status === "submitted") {
        return "View Information";
      } else {
        return this.isEdit ? "Edit Information" : "Add Information";
      }
    },
    selectedPolicyId() {
      const selectedPlan = this.plan_details.find(
        (plan) => plan.plan_id === this.form.plan_id
      );
      return selectedPlan?.policy_id;
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    resetData() {
      Object.assign(this.$data, initialState());
    },
    hideModal() {
      this.resetData();
      this.$v.form.$reset();
      this.$emit("update-isEdit", false);
      this.$bvModal.hide("uploadFileModal");
    },
    removeFile(index) {
      this.form.files.splice(index, 1);
    },
    removeFileLists(id, index) {
      this.form.deleted_files.push(id);
      this.form.file_lists.splice(index, 1);
    },
    getPolicyDetails() {
      let loader = this.$loading.show();
      let url = "prudential-claim/plan-list";
      axios
        .get(url)
        .then((res) => {
          if (res.data.status === "success") {
            this.plan_details = res.data.data;
            if(this.isEdit && this.row?.files){
              this.form.file_lists=[...this.row.files]
            }else{
              this.form.file_lists=[...this.originalFileLists]
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    fileSelected(event) {
      this.form.files = this.form.files.concat(Array.from(event.target.files));
    },
    submitFiles() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let form = this.isEdit
        ? {
            ...this.form,
            policy_id: this.selectedPolicyId || this.row.policy_id,
            claim_id: this.row.id,
            _method: "PUT",
          }
        : {
            ...this.form,
            policy_id: this.selectedPolicyId,
          };

      this.formSubmitted = true;
      let formData = new FormData();
      for (const [key, value] of Object.entries(form)) {
        if (Array.isArray(value)) {
          form[key].forEach((data, index) => {
            formData.append(`${key}[${index}]`, data);
          });
        } else {
          formData.append(key, value);
        }
      }
      if (this.form.deleted_files && this.form.deleted_files.length <= 0) {
        formData.append("deleted_files[0]", null);
      }
      let url = `prudential-claim/${this.isEdit ? "update" : "store"}`;
      this.save(url, formData);
    },
    save(url, formData) {
      let loader = this.$loading.show();
      axios
        .post(url, formData)
        .then((res) => {
          if (res.data.status === "success") {
            helper.infoMessage(this, res.data.status, res.data.message);
            this.$parent.getClaimList();
            this.hideModal();
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            helper.infoMessage(this, "error", err.response.data.message);
          } else {
            helper.infoMessage("error", "An unexpected error occurred.");
          }
          this.hideModal();
        })
        .finally(() => {
          this.formSubmitted = false;
          loader.hide();
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    showError(name) {
      return this.$v.form[name].$error;
    },
  },
  validations: {
    form: {
      plan_id: { required },
      files: {
        required(value, form) {
          return form.file_lists.length > 0 || (value && value.length > 0);
        },
      },
    },
  },
};
</script>

<style scoped>
.error-message {
  margin-top: -8px;
  margin-bottom: 10px;
  color: red;
}
.file-name-wrap {
  margin-right: 2%;
}
</style>
